import { RootState } from 'slices';

export const loginSelector = {
  getToken: (state: RootState) => state.login.token,
  getAccount: (state: RootState) => state.login.account,
};
